export default "__VITE_ASSET__CSXcoR3T__"